import type { FieldErrors } from '@/shared/api/submit';

/** Every server error message of a form, for modals whose fields don't show errors inline. */
export const ErrorList = ({ errors }: { errors: FieldErrors }) => (
  <>
    {Object.values(errors)
      .flat()
      .map((message) => (
        <p key={message} className="text-red">
          {message}
        </p>
      ))}
  </>
);
